import { CaseStyle, convertCase, makeClassName } from "@hex-insights/core";
import { Badge, BadgeProps } from "../../../../Components/Badge";
import { CalendarEventResponseResponse } from "../../../../Utilities";
import { CalendarEventResponseFormat } from "../../../Format";
import styles from "./styles.module.css";

export type ResponseBadgeProps = {
	response: CalendarEventResponseResponse;
} & Omit<BadgeProps, "color" | "backgroundColor" | "children">;

export function ResponseBadge({ response, className, ...props }: ResponseBadgeProps) {
	return (
		<Badge
			{...props}
			className={makeClassName(
				styles["response-badge"],
				styles[`response-badge--${convertCase(response, CaseStyle.Kebab)}`],
				className,
			)}
		>
			{CalendarEventResponseFormat.Fields.response(response)}
		</Badge>
	);
}
